import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  discount: null,
  discountDetails: null,
};

export const discountSlice = createSlice({
  name: "discount",
  initialState,
  reducers: {
    setDiscount: (state, action) => {
      state.discount = action.payload;
    },
    setDiscountDetails: (state, action) => {
      state.discountDetails = action.payload;
    },
    resetDiscount: (state) => {
      state.discount = null;
      state.discountDetails = null;
    },
  },
});

export const { setDiscount, setDiscountDetails, resetDiscount } = discountSlice.actions;

export default discountSlice.reducer;
